<template>
  <div ref="container"
       class="break-words"
       v-html="content"
  />
</template>

<script setup lang="ts">
import slugify from 'slugify'
import { ref, onMounted } from 'vue'

type BlogTextProps = {
  content: string
}

defineProps<BlogTextProps>()

const container = ref<HTMLElement | null>(null)

// Find all headings and add an anchor link to them as a slug of the content
onMounted(() => {
  const headings = container.value?.querySelectorAll('h2, h3, h4, h5, h6')
  headings?.forEach(heading => {
    heading.setAttribute('id', slugify(heading.textContent || '', { lower: true }))
  })
})
</script>
